import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ScrollReveal from "../ScrollReveal";
import { SERVICES } from "../../data/content";

export const Services = ({ showAll = true, limit = 6 }) => {
  const list = showAll ? SERVICES : SERVICES.slice(0, limit);

  return (
    <section
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / Our Services
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1]">
              <br />
              <span className="text-white/40">Sharper outcomes.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-sm md:text-base leading-relaxed">
            From brand identity to full Shopify builds — everything you need to
            scale your ecommerce brand, delivered with obsidian precision.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {list.map((s, i) => {
            const Icon = s.icon;
            return (
              <ScrollReveal key={s.slug} delay={i * 0.06}>
                <Link
                  to={`/services#${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group relative flex flex-col h-full bg-[#080808] p-8 md:p-10 hover:bg-[#0e0e0e] transition-colors shine-box"
                >
                  <div className="flex items-center justify-between mb-8">
                    <div className="w-12 h-12 border border-white/15 flex items-center justify-center group-hover:bg-violet-500 group-hover:border-violet-500 group-hover:text-white transition-colors">
                      <Icon size={20} strokeWidth={1.4} />
                    </div>
                    <ArrowUpRight
                      size={18}
                      className="text-white/30 group-hover:text-violet-300 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                    />
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-extrabold uppercase tracking-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-white/55 leading-relaxed mb-6 flex-1">
                    {s.summary}
                  </p>
                  <div className="flex items-center justify-between pt-5 border-t border-white/10">
                    <div className="text-[10px] uppercase tracking-[0.3em] text-violet-300/70">
                      {s.title.split(" ")[0]}
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 group-hover:text-violet-300 transition-colors">
                      Explore →
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
